// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-dashboard-certifications--layout {\n  width: 100%;\n  gap: 15px;\n  display: flex;\n  flex-direction: column; }\n  .student-dashboard-certifications--layout .student-dashboard-certifications--actions {\n    display: flex;\n    align-items: flex-end;\n    gap: 10px; }\n", ""]);
// Exports
module.exports = exports;
